export default {

    'sessao': {
        namespaced: true,
        ...require('@/aplicacao/stores/sessao').default,
    },

    'flash': {
        namespaced: true,
        ...require('@/aplicacao/stores/flash').default,
    },

    'geral': {
        namespaced: true,
        ...require('@/aplicacao/stores/geral').default,
    },

    'pendencias': {
        namespaced: true,
        ...require('@/aplicacao/stores/pendencias').default,
    },

    'lightbox': {
        namespaced: true,
        ...require('@/aplicacao/stores/lightbox').default,
    },

    'utilitarios': {
        namespaced: true,
        ...require('@/aplicacao/stores/utilitarios').default,
    },

    'camera': {
        namespaced: true,
        ...require('@/aplicacao/stores/camera').default,
    },

    'modulos': {
        namespaced: true,
        modules: {
            ...require('@/aplicacao/modulos/_configuracoes/stores').default,
        },
    },

}
